import dayjs from "dayjs";
import { DurationUnitType } from "dayjs/plugin/duration";
import { t } from "i18next";
import { toast } from "react-hot-toast";
import _ from "lodash";
import TreatmentType from "types/TreatmentType.enum";

export const userInitials = (name) => {
  if (name) {
    const [firstName, lastName] = name.split(" ");
    return _.defaultTo(firstName?.at(0), "") + _.defaultTo(lastName?.at(0), "");
  }
  return "";
};

export const hasPinExpired = (expiry: string | Date): boolean => {
  return dayjs(expiry).isBefore(dayjs());
};

export const toDate = (date, format) => {
  const parsedDate = dayjs(date);
  if (parsedDate.isValid()) {
    return parsedDate.format(format);
  } else {
    return null;
  }
};

export const zeroPad = (num: number | string, places: number): string => {
  return String(num).padStart(places, "0");
};

export const formatDuration = (
  time: number,
  unit: DurationUnitType,
  format: string
) => {
  if (typeof time === "number") {
    const duration = dayjs.duration(Math.max(time, 0), unit);
    const h = Math.floor(duration.asHours());
    const m = duration.minutes();
    const s = duration.seconds();
    return `${zeroPad(h, 2)}:${zeroPad(m, 2)}:${zeroPad(s, 2)}`;
  } else {
    return null;
  }
};

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(t("common.copiedSuccessfully"));
  } catch (err) {
    toast.error(t("common.failedToCopy"));
  }
};

export const isPresent = (value) => {
  if (typeof value === "undefined" || value === null) {
    return false;
  }
  return true;
};

export const removeProhibitedCharacters = (
  event,
  prohibitedCharacters,
  replaceWith = ""
) => {
  event.target.value = event.target.value.replace(
    prohibitedCharacters,
    replaceWith
  );
};

export const encode = (value) => {
  try {
    return encodeURIComponent(value);
  } catch (e) {
    return value;
  }
};

export const decode = (value) => {
  try {
    return decodeURIComponent(value);
  } catch (e) {
    return value;
  }
};

export const getFromSessionStorage = (key: string, defaultValue: any) => {
  const item = window.sessionStorage.getItem(key);
  if (item) {
    return JSON.parse(item);
  } else {
    return defaultValue;
  }
};

export const setInSessionStorage = (key: string, value: any) => {
  window.sessionStorage.setItem(key, JSON.stringify(value));
};

export const getTreatmentType = (treatmentType: string) => {
  if (treatmentType?.includes(TreatmentType.rateBased)) {
    return TreatmentType.rateBased;
  } else if (treatmentType?.includes(TreatmentType.volumeBased)) {
    return TreatmentType.volumeBased;
  } else {
    return TreatmentType.volumeBased;
  }
};
